var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _rect9, _rect10, _rect11, _rect12, _path3, _path4, _path5, _rect13, _g, _g2, _g3, _g4, _g5, _g6, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path6, _rect27, _rect28, _path7, _rect29, _rect30, _path8, _rect31, _path9, _path10, _rect32, _rect33, _rect34, _rect35, _rect36, _path11, _path12, _path13, _rect37, _g7, _g8, _g9, _g10, _g11, _g12, _rect38, _rect39, _rect40, _path14, _path15, _path16, _path17, _rect41, _rect42, _path18, _path19, _g13, _path20, _path21, _path22, _path23, _path24, _path25, _g14, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g15, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g16, _g17, _path54, _path55, _g18, _path56, _path57, _path58, _g19, _path59, _g20, _path60, _path61, _path62, _g21, _path63, _g22, _path64, _g23, _path65, _path66;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BLOCKED",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 372.56,
    viewBox: "0 0 500 372.56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9473",
    "data-name": "Ret\\xE2ngulo 9473",
    width: 500,
    height: 372.56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9420",
    "data-name": "Ret\\xE2ngulo 9420",
    width: 138.32,
    height: 6.59,
    transform: "translate(284.1 37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9421",
    "data-name": "Ret\\xE2ngulo 9421",
    width: 138.32,
    height: 6.58,
    transform: "translate(284.1 47.81)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9422",
    "data-name": "Ret\\xE2ngulo 9422",
    width: 138.32,
    height: 6.58,
    transform: "translate(284.1 58.61)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9423",
    "data-name": "Ret\\xE2ngulo 9423",
    width: 138.32,
    height: 6.59,
    transform: "translate(284.1 69.41)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9424",
    "data-name": "Ret\\xE2ngulo 9424",
    width: 138.32,
    height: 6.59,
    transform: "translate(284.1 80.21)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9425",
    "data-name": "Ret\\xE2ngulo 9425",
    width: 138.32,
    height: 6.59,
    transform: "translate(284.1 91.01)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9450",
    "data-name": "Ret\\xE2ngulo 9450",
    width: 138.32,
    height: 6.59,
    transform: "translate(68.47 37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9451",
    "data-name": "Ret\\xE2ngulo 9451",
    width: 138.32,
    height: 6.59,
    transform: "translate(68.47 40.72)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9452",
    "data-name": "Ret\\xE2ngulo 9452",
    width: 138.32,
    height: 6.58,
    transform: "translate(68.47 44.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9453",
    "data-name": "Ret\\xE2ngulo 9453",
    width: 138.32,
    height: 6.59,
    transform: "translate(68.47 48.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9454",
    "data-name": "Ret\\xE2ngulo 9454",
    width: 138.32,
    height: 6.58,
    transform: "translate(68.47 51.87)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9455",
    "data-name": "Ret\\xE2ngulo 9455",
    width: 138.32,
    height: 6.59,
    transform: "translate(68.47 55.58)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9461",
    "data-name": "Ret\\xE2ngulo 9461",
    width: 242.353,
    height: 163.742,
    transform: "translate(104.379 96.419)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9462",
    "data-name": "Ret\\xE2ngulo 9462",
    width: 77.257,
    height: 82.816,
    transform: "translate(188.017 144.457)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9463",
    "data-name": "Ret\\xE2ngulo 9463",
    width: 8.72,
    height: 10,
    transform: "translate(348.64 333.29)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9464",
    "data-name": "Ret\\xE2ngulo 9464",
    width: 29.386,
    height: 177.24,
    transform: "translate(330.05 164.12)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9465",
    "data-name": "Ret\\xE2ngulo 9465",
    width: 7.359,
    height: 62.316,
    transform: "translate(330.61 185.544)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9466",
    "data-name": "Ret\\xE2ngulo 9466",
    width: 16.852,
    height: 24.084,
    transform: "translate(348.728 110.58)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9467",
    "data-name": "Ret\\xE2ngulo 9467",
    width: 12.04,
    height: 12.57,
    transform: "translate(334.55 318.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9468",
    "data-name": "Ret\\xE2ngulo 9468",
    width: 44.519,
    height: 164.4,
    transform: "translate(302.091 164.12)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9469",
    "data-name": "Ret\\xE2ngulo 9469",
    width: 18.204,
    height: 26.105,
    transform: "translate(310 107.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9470",
    "data-name": "Ret\\xE2ngulo 9470",
    width: 45,
    height: 52.978,
    transform: "translate(316.07 111.142)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9471",
    "data-name": "Ret\\xE2ngulo 9471",
    width: 37.148,
    height: 3.748,
    transform: "translate(320.01 161.862)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13759",
    "data-name": "Grupo 13759",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9407",
    "data-name": "Ret\\xE2ngulo 9407",
    width: 500,
    height: 0.25,
    transform: "translate(0 327.4)",
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9408",
    "data-name": "Ret\\xE2ngulo 9408",
    width: 33.12,
    height: 0.25,
    transform: "translate(416.78 343.49)",
    fill: "#ebebeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9409",
    "data-name": "Ret\\xE2ngulo 9409",
    width: 8.69,
    height: 0.25,
    transform: "translate(322.53 346.21)",
    fill: "#ebebeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9410",
    "data-name": "Ret\\xE2ngulo 9410",
    width: 19.19,
    height: 0.25,
    transform: "translate(396.59 334.21)",
    fill: "#ebebeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9411",
    "data-name": "Ret\\xE2ngulo 9411",
    width: 43.19,
    height: 0.249,
    transform: "translate(52.46 335.891)",
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9412",
    "data-name": "Ret\\xE2ngulo 9412",
    width: 6.33,
    height: 0.249,
    transform: "translate(104.56 335.891)",
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9413",
    "data-name": "Ret\\xE2ngulo 9413",
    width: 93.68,
    height: 0.25,
    transform: "translate(131.47 340.11)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13758",
    "data-name": "Grupo 13758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13757",
    "data-name": "Grupo 13757",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7828",
    "data-name": "Caminho 7828",
    d: "M237,282.8H43.91a5.71,5.71,0,0,1-5.7-5.71V5.66A5.71,5.71,0,0,1,43.91,0H237a5.709,5.709,0,0,1,5.71,5.71V277.09A5.709,5.709,0,0,1,237,282.8M43.91.2a5.459,5.459,0,0,0-5.45,5.46V277.09a5.46,5.46,0,0,0,5.45,5.46H237a5.471,5.471,0,0,0,5.46-5.46V5.66A5.47,5.47,0,0,0,237,.2Z",
    fill: "#ebebeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7829",
    "data-name": "Caminho 7829",
    d: "M453.31,282.8H260.21a5.721,5.721,0,0,1-5.71-5.71V5.66A5.72,5.72,0,0,1,260.21,0h193.1A5.71,5.71,0,0,1,459,5.66V277.09a5.71,5.71,0,0,1-5.69,5.71M260.21.2a5.47,5.47,0,0,0-5.46,5.46V277.09a5.471,5.471,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V5.66A5.47,5.47,0,0,0,453.31.2Z",
    fill: "#ebebeb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9414",
    "data-name": "Ret\\xE2ngulo 9414",
    width: 137.78,
    height: 90.23,
    transform: "translate(289.69 28.83)",
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9415",
    "data-name": "Ret\\xE2ngulo 9415",
    width: 140.02,
    height: 90.23,
    transform: "translate(285.48 28.83)",
    fill: "#f0f0f0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9416",
    "data-name": "Ret\\xE2ngulo 9416",
    width: 137.78,
    height: 17.71,
    transform: "translate(289.69 119.05)",
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9417",
    "data-name": "Ret\\xE2ngulo 9417",
    width: 140.02,
    height: 17.71,
    transform: "translate(278.49 119.05)",
    fill: "#f0f0f0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9418",
    "data-name": "Ret\\xE2ngulo 9418",
    width: 128.25,
    height: 78.46,
    transform: "translate(291.37 34.72)",
    fill: "#fafafa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7830",
    "data-name": "Caminho 7830",
    d: "M390.7,113.17,374.32,34.72H348.76l16.38,78.45Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7831",
    "data-name": "Caminho 7831",
    d: "M416.9,107.32a.42.42,0,0,0,.42-.42V38.55a.42.42,0,0,0-.42-.42.41.41,0,0,0-.42.4v68.36a.42.42,0,0,0,.41.43h.01",
    fill: "#f0f0f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7832",
    "data-name": "Caminho 7832",
    d: "M359.65,113.17,343.27,34.72H333.3l16.39,78.45Z",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9419",
    "data-name": "Ret\\xE2ngulo 9419",
    width: 0.75,
    height: 78.46,
    transform: "translate(291.37 34.72)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13690",
    "data-name": "Grupo 13690",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13689",
    "data-name": "Grupo 13689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13688",
    "data-name": "Grupo 13688",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7833",
    "data-name": "Caminho 7833",
    d: "M284.1,43.59H421.88l.54-6.59H284.64Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13693",
    "data-name": "Grupo 13693",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13692",
    "data-name": "Grupo 13692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13691",
    "data-name": "Grupo 13691",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7834",
    "data-name": "Caminho 7834",
    d: "M284.1,54.39H421.88l.54-6.58H284.64Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13696",
    "data-name": "Grupo 13696",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13695",
    "data-name": "Grupo 13695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13694",
    "data-name": "Grupo 13694",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7835",
    "data-name": "Caminho 7835",
    d: "M284.1,65.19H421.88l.54-6.58H284.64Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13699",
    "data-name": "Grupo 13699",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13698",
    "data-name": "Grupo 13698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13697",
    "data-name": "Grupo 13697",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7836",
    "data-name": "Caminho 7836",
    d: "M284.1,76H421.88l.54-6.59H284.64Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13702",
    "data-name": "Grupo 13702",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13701",
    "data-name": "Grupo 13701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13700",
    "data-name": "Grupo 13700",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7837",
    "data-name": "Caminho 7837",
    d: "M284.1,86.8H421.88l.54-6.59H284.64Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13705",
    "data-name": "Grupo 13705",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13704",
    "data-name": "Grupo 13704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13703",
    "data-name": "Grupo 13703",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7838",
    "data-name": "Caminho 7838",
    d: "M284.1,97.6H421.88l.54-6.59H284.64Z",
    fill: "#ebebeb"
  }))))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9426",
    "data-name": "Ret\\xE2ngulo 9426",
    width: 28.89,
    height: 5.7,
    transform: "translate(378.8 261.78)",
    fill: "#e6e6e6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9427",
    "data-name": "Ret\\xE2ngulo 9427",
    width: 5.33,
    height: 131.07,
    transform: "translate(324.31 196.33)",
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9428",
    "data-name": "Ret\\xE2ngulo 9428",
    width: 72.96,
    height: 5.7,
    transform: "translate(305.83 261.78)",
    fill: "#f5f5f5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9429",
    "data-name": "Ret\\xE2ngulo 9429",
    width: 28.89,
    height: 5.7,
    transform: "translate(378.8 292.95)",
    fill: "#e6e6e6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9430",
    "data-name": "Ret\\xE2ngulo 9430",
    width: 72.96,
    height: 5.7,
    transform: "translate(305.83 292.94)",
    fill: "#f5f5f5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9431",
    "data-name": "Ret\\xE2ngulo 9431",
    width: 28.89,
    height: 5.7,
    transform: "translate(378.8 199.45)",
    fill: "#e6e6e6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9432",
    "data-name": "Ret\\xE2ngulo 9432",
    width: 72.96,
    height: 5.7,
    transform: "translate(305.83 199.44)",
    fill: "#f5f5f5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9433",
    "data-name": "Ret\\xE2ngulo 9433",
    width: 28.89,
    height: 5.7,
    transform: "translate(378.8 230.61)",
    fill: "#e6e6e6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9434",
    "data-name": "Ret\\xE2ngulo 9434",
    width: 72.96,
    height: 5.7,
    transform: "translate(305.83 230.61)",
    fill: "#f5f5f5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9435",
    "data-name": "Ret\\xE2ngulo 9435",
    width: 5.33,
    height: 131.07,
    transform: "translate(397.28 196.33)",
    fill: "#e6e6e6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9436",
    "data-name": "Ret\\xE2ngulo 9436",
    width: 5.33,
    height: 131.07,
    transform: "translate(373.46 196.33)",
    fill: "#f5f5f5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9437",
    "data-name": "Ret\\xE2ngulo 9437",
    width: 5.33,
    height: 131.07,
    transform: "translate(305.83 196.33)",
    fill: "#f5f5f5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9438",
    "data-name": "Ret\\xE2ngulo 9438",
    width: 54.58,
    height: 105.89,
    transform: "translate(65.38 221.51)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7839",
    "data-name": "Caminho 7839",
    d: "M79.95,327.4H65.37V312.78H95.23Z",
    fill: "#fafafa"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9439",
    "data-name": "Ret\\xE2ngulo 9439",
    width: 54.58,
    height: 105.89,
    transform: "translate(214.18 221.51)",
    fill: "#e6e6e6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9440",
    "data-name": "Ret\\xE2ngulo 9440",
    width: 161.53,
    height: 100.86,
    transform: "translate(65.38 221.5)",
    fill: "#fafafa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7840",
    "data-name": "Caminho 7840",
    d: "M212.33,327.4H226.9V312.78H197.05Z",
    fill: "#fafafa"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9441",
    "data-name": "Ret\\xE2ngulo 9441",
    width: 138.92,
    height: 25.24,
    transform: "translate(76.68 259.09)",
    fill: "#f0f0f0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9442",
    "data-name": "Ret\\xE2ngulo 9442",
    width: 138.92,
    height: 25.24,
    transform: "translate(76.68 289.72)",
    fill: "#f0f0f0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7841",
    "data-name": "Caminho 7841",
    d: "M189.2,261.79H103.09a4.581,4.581,0,0,1-4.58-4.58v-.31h95.26v.31a4.58,4.58,0,0,1-4.57,4.58",
    fill: "#fafafa"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9443",
    "data-name": "Ret\\xE2ngulo 9443",
    width: 138.92,
    height: 25.24,
    transform: "translate(76.68 228.45)",
    fill: "#f0f0f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7842",
    "data-name": "Caminho 7842",
    d: "M189.2,231.15H103.09a4.581,4.581,0,0,1-4.58-4.58v-.31h95.26v.31a4.58,4.58,0,0,1-4.57,4.58",
    fill: "#fafafa"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7843",
    "data-name": "Caminho 7843",
    d: "M189.2,292.43H103.09a4.581,4.581,0,0,1-4.58-4.58v-.31h95.26v.31a4.58,4.58,0,0,1-4.57,4.58",
    fill: "#fafafa"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9444",
    "data-name": "Ret\\xE2ngulo 9444",
    width: 137.78,
    height: 90.23,
    transform: "translate(74.07 28.83)",
    fill: "#e6e6e6"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9445",
    "data-name": "Ret\\xE2ngulo 9445",
    width: 140.02,
    height: 90.23,
    transform: "translate(69.87 28.83)",
    fill: "#f0f0f0"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9446",
    "data-name": "Ret\\xE2ngulo 9446",
    width: 137.78,
    height: 17.71,
    transform: "translate(74.07 119.05)",
    fill: "#e6e6e6"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9447",
    "data-name": "Ret\\xE2ngulo 9447",
    width: 140.02,
    height: 17.71,
    transform: "translate(62.86 119.05)",
    fill: "#f0f0f0"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9448",
    "data-name": "Ret\\xE2ngulo 9448",
    width: 128.25,
    height: 78.46,
    transform: "translate(75.75 34.72)",
    fill: "#fafafa"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7844",
    "data-name": "Caminho 7844",
    d: "M175.08,113.17,158.7,34.72H133.14l16.38,78.45Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7845",
    "data-name": "Caminho 7845",
    d: "M201.27,107.32a.42.42,0,0,0,.42-.42V38.55a.41.41,0,0,0-.4-.42h-.02a.42.42,0,0,0-.42.42v68.34a.42.42,0,0,0,.41.43h.01",
    fill: "#f0f0f0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7846",
    "data-name": "Caminho 7846",
    d: "M144.03,113.17,127.65,34.72h-9.97l16.38,78.45Z",
    fill: "#fff"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9449",
    "data-name": "Ret\\xE2ngulo 9449",
    width: 0.75,
    height: 78.46,
    transform: "translate(75.75 34.72)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13708",
    "data-name": "Grupo 13708",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13707",
    "data-name": "Grupo 13707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13706",
    "data-name": "Grupo 13706",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7847",
    "data-name": "Caminho 7847",
    d: "M68.47,43.59H206.25l.54-6.59H69.01Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13711",
    "data-name": "Grupo 13711",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13710",
    "data-name": "Grupo 13710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13709",
    "data-name": "Grupo 13709",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7848",
    "data-name": "Caminho 7848",
    d: "M68.47,47.31H206.25l.54-6.59H69.01Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13714",
    "data-name": "Grupo 13714",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13713",
    "data-name": "Grupo 13713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13712",
    "data-name": "Grupo 13712",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7849",
    "data-name": "Caminho 7849",
    d: "M68.47,51.02H206.25l.54-6.58H69.01Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13717",
    "data-name": "Grupo 13717",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13716",
    "data-name": "Grupo 13716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13715",
    "data-name": "Grupo 13715",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7850",
    "data-name": "Caminho 7850",
    d: "M68.47,54.74H206.25l.54-6.59H69.01Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13720",
    "data-name": "Grupo 13720",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13719",
    "data-name": "Grupo 13719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13718",
    "data-name": "Grupo 13718",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7851",
    "data-name": "Caminho 7851",
    d: "M68.47,58.45H206.25l.54-6.58H69.01Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13723",
    "data-name": "Grupo 13723",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13722",
    "data-name": "Grupo 13722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13721",
    "data-name": "Grupo 13721",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7852",
    "data-name": "Caminho 7852",
    d: "M68.47,62.17H206.25l.54-6.59H69.01Z",
    fill: "#ebebeb"
  }))))), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9456",
    "data-name": "Ret\\xE2ngulo 9456",
    width: 4.76,
    height: 53.09,
    transform: "translate(96.02 165.18)",
    fill: "#f5f5f5"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9457",
    "data-name": "Ret\\xE2ngulo 9457",
    width: 1.35,
    height: 53.09,
    transform: "translate(96.62 165.15)",
    fill: "#fafafa"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9458",
    "data-name": "Ret\\xE2ngulo 9458",
    width: 0.53,
    height: 53.09,
    transform: "translate(98.53 165.15)",
    fill: "#fafafa"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7853",
    "data-name": "Caminho 7853",
    d: "M116.03,221.51H80.79a4.44,4.44,0,0,1,4.44-4.44h26.35a4.44,4.44,0,0,1,4.44,4.44Z",
    fill: "#f0f0f0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7854",
    "data-name": "Caminho 7854",
    d: "M89.84,198.14h0a1.38,1.38,0,0,0,1.37-1.37V162a1.375,1.375,0,0,0-2.75-.01v34.82a1.38,1.38,0,0,0,1.38,1.33",
    fill: "#f0f0f0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7855",
    "data-name": "Caminho 7855",
    d: "M77.07,177.8h42.65L114.81,148H81.98Z",
    fill: "#e0e0e0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7856",
    "data-name": "Caminho 7856",
    d: "M250,349.92c107.082,0,193.89,5.068,193.89,11.32S357.082,372.56,250,372.56,56.11,367.492,56.11,361.24,142.918,349.92,250,349.92",
    fill: "#f5f5f5"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9459",
    "data-name": "Ret\\xE2ngulo 9459",
    width: 1,
    height: 18.49,
    transform: "translate(103.119 147.431) rotate(-4.131)",
    fill: "#ff6461"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9460",
    "data-name": "Ret\\xE2ngulo 9460",
    width: 1,
    height: 6.96,
    transform: "translate(105.127 175.394) rotate(-4.131)",
    fill: "#ff6461"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7857",
    "data-name": "Caminho 7857",
    d: "M337.71,260.16H123.55a9.651,9.651,0,0,1-9.44-8.81L103.59,105.22a8.1,8.1,0,0,1,7.369-8.77c.266-.023.534-.033.8-.03H325.92a9.65,9.65,0,0,1,9.44,8.8l10.52,146.13a8.11,8.11,0,0,1-7.379,8.78q-.395.035-.791.03",
    fill: "#ff6461"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7858",
    "data-name": "Caminho 7858",
    d: "M338.53,260.16H124.37a9.651,9.651,0,0,1-9.44-8.81L104.41,105.22a8.1,8.1,0,0,1,7.369-8.77c.266-.023.534-.033.8-.03H326.74a9.65,9.65,0,0,1,9.44,8.8L346.7,251.35a8.1,8.1,0,0,1-7.358,8.779q-.405.036-.812.031",
    fill: "#ff6461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13726",
    "data-name": "Grupo 13726",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13725",
    "data-name": "Grupo 13725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13724",
    "data-name": "Grupo 13724",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7859",
    "data-name": "Caminho 7859",
    d: "M338.53,260.16H124.37a9.651,9.651,0,0,1-9.44-8.81L104.41,105.22a8.1,8.1,0,0,1,7.369-8.77c.266-.023.534-.033.8-.03H326.74a9.65,9.65,0,0,1,9.44,8.8L346.7,251.35a8.1,8.1,0,0,1-7.358,8.779q-.405.036-.812.031",
    fill: "#fff"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7860",
    "data-name": "Caminho 7860",
    d: "M327.06,100.82H112.18c-5.47.45-4.35,8.78,1.17,8.78H327.87c5.53,0,5.45-8.33-.09-8.78Z",
    fill: "#ff6461"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7861",
    "data-name": "Caminho 7861",
    d: "M118.48,105.22a1.85,1.85,0,0,1-1.694,1.994q-.093.008-.186.006a2.2,2.2,0,0,1-2.16-2,1.85,1.85,0,0,1,1.694-1.994,1.716,1.716,0,0,1,.176-.006,2.2,2.2,0,0,1,2.17,2",
    fill: "#fafafa"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7862",
    "data-name": "Caminho 7862",
    d: "M125.35,105.22a1.85,1.85,0,0,1-1.694,1.994q-.093.008-.186.006a2.2,2.2,0,0,1-2.16-2A1.85,1.85,0,0,1,123,103.226a1.716,1.716,0,0,1,.176-.006,2.2,2.2,0,0,1,2.17,2",
    fill: "#fafafa"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7863",
    "data-name": "Caminho 7863",
    d: "M132.21,105.22a1.85,1.85,0,0,1-1.694,1.994,1.714,1.714,0,0,1-.176.006,2.191,2.191,0,0,1-2.16-2,1.844,1.844,0,0,1,1.87-2,2.2,2.2,0,0,1,2.16,2",
    fill: "#fafafa"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7864",
    "data-name": "Caminho 7864",
    d: "M332.85,245.58H128a3.49,3.49,0,0,1-3.42-3.2l-8.65-120.17a2.92,2.92,0,0,1,2.636-3.179,2.951,2.951,0,0,1,.364-.011h204.9a3.48,3.48,0,0,1,3.42,3.19l8.66,120.17a2.94,2.94,0,0,1-2.665,3.191,2.893,2.893,0,0,1-.395.009",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7865",
    "data-name": "Caminho 7865",
    d: "M306.326,231.206H155.68a7.331,7.331,0,0,1-7.157-6.6l-7.08-84.537a6,6,0,0,1,6.073-6.6H298.188a7.331,7.331,0,0,1,7.157,6.6l7.037,84.58a6,6,0,0,1-5.422,6.534,6.118,6.118,0,0,1-.634.025",
    fill: "#f0f0f0"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13729",
    "data-name": "Grupo 13729",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13728",
    "data-name": "Grupo 13728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13727",
    "data-name": "Grupo 13727",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7866",
    "data-name": "Caminho 7866",
    d: "M265.274,185.865c0,22.869-17.295,41.408-38.629,41.408s-38.628-18.539-38.628-41.408,17.294-41.408,38.628-41.408S265.274,163,265.274,185.865",
    fill: "#263238"
  }))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7867",
    "data-name": "Caminho 7867",
    d: "M270.98,178.178c0,22.869-17.3,41.408-38.629,41.408s-38.628-18.539-38.628-41.408,17.294-41.408,38.628-41.408,38.629,18.539,38.629,41.408",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7868",
    "data-name": "Caminho 7868",
    d: "M232.352,219.6c-21.305,0-38.638-18.58-38.638-41.418s17.333-41.418,38.638-41.418,38.638,18.58,38.638,41.418S253.657,219.6,232.352,219.6m0-77.276c-18.445,0-33.452,16.086-33.452,35.858s15.007,35.858,33.452,35.858S265.8,197.951,265.8,178.178,250.8,142.32,232.352,142.32",
    fill: "#ff6461"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7869",
    "data-name": "Caminho 7869",
    d: "M251.924,142.483l-52.872,56.676a40.425,40.425,0,0,0,12.942,14.207l53.184-57.01a40.24,40.24,0,0,0-13.254-13.873",
    fill: "#ff6461"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7870",
    "data-name": "Caminho 7870",
    d: "M353.69,118.08c.89-.45,2-1,2.94-1.57s2-1.12,3-1.72c1.95-1.21,3.93-2.4,5.8-3.72a76.973,76.973,0,0,0,10.52-8.66c.41-.38.77-.8,1.16-1.21l.57-.61.28-.3.14-.16c-.14.27,0,.19,0-.07a5.27,5.27,0,0,0,.15-1.09,30.619,30.619,0,0,0-.73-6.32c-.89-4.48-2.24-9.1-3.57-13.62l3.88-1.7a81.319,81.319,0,0,1,6.11,13.6,31.64,31.64,0,0,1,1.72,7.89,12.039,12.039,0,0,1-.08,2.51,7.7,7.7,0,0,1-1.22,3.29l-.17.23-.13.16-.15.19-.31.38-.62.75c-.41.49-.81,1-1.25,1.47A71.867,71.867,0,0,1,370.35,118a75.487,75.487,0,0,1-6.29,4.19c-1.07.65-2.16,1.27-3.27,1.88s-2.19,1.17-3.47,1.77Z",
    fill: "#1ed6bb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7871",
    "data-name": "Caminho 7871",
    d: "M344.79,353.18a10.262,10.262,0,0,0,2.22-.3.221.221,0,0,0,.15-.16.21.21,0,0,0-.09-.2c-.29-.19-2.83-1.83-3.81-1.39a.68.68,0,0,0-.39.56,1.129,1.129,0,0,0,.33,1.05,2.35,2.35,0,0,0,1.59.44m1.65-.58c-1.45.29-2.55.24-3-.15a.771.771,0,0,1-.2-.71.3.3,0,0,1,.17-.25c.53-.23,2,.51,3.03,1.11",
    fill: "#ff6461"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7872",
    "data-name": "Caminho 7872",
    d: "M347,352.88h.1a.209.209,0,0,0,.1-.17c0-.11,0-2.52-.92-3.32a1,1,0,0,0-.84-.27.691.691,0,0,0-.67.55c-.19,1,1.33,2.75,2.13,3.21a.189.189,0,0,0,.1,0m-1.43-3.39a.662.662,0,0,1,.44.17,4.528,4.528,0,0,1,.78,2.64c-.8-.64-1.75-2-1.63-2.57,0-.09.07-.21.32-.24Z",
    fill: "#ff6461"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7873",
    "data-name": "Caminho 7873",
    d: "M346.22,93.07c-1,5-3,15,.45,18.35,0,0-1.36,5-10.59,5-10.16,0-4.85-5-4.85-5,5.54-1.32,5.39-5.43,4.43-9.3Z",
    fill: "#1ed6bb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7874",
    "data-name": "Caminho 7874",
    d: "M329.28,113.42c-1.59.22-.23-3.91.41-4.34,1.5-1,20.86-2.39,20.73,0-.08,1-.56,3-1.4,3.66s-5.82-1.4-19.74.68",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7875",
    "data-name": "Caminho 7875",
    d: "M332.44,112c-1.27.43-1.15-3.73-.72-4.23,1-1.16,16.67-5.18,17.13-2.91.18,1,.27,3-.27,3.71s-5.14-.46-16.14,3.43",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7876",
    "data-name": "Caminho 7876",
    d: "M326.61,84.11a.4.4,0,0,1-.33-.15,3.178,3.178,0,0,0-2.59-1.23.389.389,0,0,1-.438-.335l0-.015a.4.4,0,0,1,.35-.43,3.911,3.911,0,0,1,3.29,1.51.4.4,0,0,1-.05.56.494.494,0,0,1-.23.09",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7877",
    "data-name": "Caminho 7877",
    d: "M324.67,89a17.932,17.932,0,0,1-2,4.53,2.9,2.9,0,0,0,2.44.21Z",
    fill: "#ff5652"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7878",
    "data-name": "Caminho 7878",
    d: "M325.16,87.79c.07.67-.24,1.25-.68,1.29s-.85-.46-.91-1.14.24-1.25.67-1.29.85.46.92,1.14",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7879",
    "data-name": "Caminho 7879",
    d: "M324.44,86.67l-1.66-.31s.95,1.18,1.66.31",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7880",
    "data-name": "Caminho 7880",
    d: "M356.7,352.69h-8.38l.66-19.4h8.38Z",
    fill: "#1ed6bb"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7881",
    "data-name": "Caminho 7881",
    d: "M347.66,351.72h9.41a.66.66,0,0,1,.67.57l1.07,7.44a1.34,1.34,0,0,1-1.182,1.482,1.386,1.386,0,0,1-.158.008c-3.28-.05-4.86-.25-9-.25-2.55,0-6.27.27-9.78.27s-3.71-3.48-2.24-3.79c6.56-1.42,7.6-3.36,9.81-5.22a2.211,2.211,0,0,1,1.4-.51",
    fill: "#263238"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13732",
    "data-name": "Grupo 13732",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13731",
    "data-name": "Grupo 13731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13730",
    "data-name": "Grupo 13730",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7882",
    "data-name": "Caminho 7882",
    d: "M357.36,333.29h-8.38l-.34,10h8.38Z"
  }))))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7883",
    "data-name": "Caminho 7883",
    d: "M323.37,123a162.588,162.588,0,0,1-15.05-6.75,91.323,91.323,0,0,1-14.4-8.77,34.322,34.322,0,0,1-3.42-3.07c-.28-.3-.56-.58-.83-.93a11.289,11.289,0,0,1-.88-1.13,7.9,7.9,0,0,1-1.34-3.61,8.221,8.221,0,0,1,.49-3.62,10.647,10.647,0,0,1,1.41-2.6A18.122,18.122,0,0,1,292.74,89a42.027,42.027,0,0,1,7.3-4.67c1.24-.66,2.5-1.25,3.78-1.8s2.54-1.07,3.91-1.54l1.77,3.85c-4.36,2.75-8.88,5.78-12.2,9.16a13.855,13.855,0,0,0-1.95,2.49c-.48.79-.47,1.38-.39,1.33s0,0,.14.1l.4.43c.15.18.36.36.55.55a25.612,25.612,0,0,0,2.69,2.16,62.875,62.875,0,0,0,6.44,4c2.25,1.26,4.57,2.45,6.93,3.59,4.72,2.26,9.6,4.43,14.39,6.41Z",
    fill: "#1ed6bb"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7884",
    "data-name": "Caminho 7884",
    d: "M312,82.15l1.38-3L307.06,77s-2,5.91.37,8.63A6.05,6.05,0,0,0,312,82.15",
    fill: "#1ed6bb"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7885",
    "data-name": "Caminho 7885",
    d: "M313.35,72.66l-5.03-1.46-1.26,5.76,6.29,2.19Z",
    fill: "#1ed6bb"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7886",
    "data-name": "Caminho 7886",
    d: "M378.35,79.44l.73-7L372.6,74s-.1,6.58,3.33,7.62Z",
    fill: "#1ed6bb"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7887",
    "data-name": "Caminho 7887",
    d: "M375.96,67.51l-4.23,1.97.87,4.47,6.48-1.53Z",
    fill: "#1ed6bb"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7888",
    "data-name": "Caminho 7888",
    d: "M347.54,83.25c.31,8.31.61,11.82-3.14,16.47-5.65,7-15.92,5.55-18.7-2.5-2.5-7.24-2.58-19.61,5.18-23.69a11.341,11.341,0,0,1,16.66,9.72",
    fill: "#1ed6bb"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7889",
    "data-name": "Caminho 7889",
    d: "M343.92,99.71c8.16-3.53,13.52-11,11.26-22.58-2.17-11.11-9.67-12.21-12.77-9.91s-10.83-1.13-15.47,2.77c-8,6.77-.44,14,3.52,18.37,2.36,4.86,5.46,14.8,13.46,11.35",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7890",
    "data-name": "Caminho 7890",
    d: "M340.53,75.14a8.29,8.29,0,1,0,1.83-11.92,8.53,8.53,0,0,0-1.83,11.92",
    fill: "#ff6461"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7891",
    "data-name": "Caminho 7891",
    d: "M342.65,68c-1.17-6.7,5.16-11.86,13.64-9.37s4,10,2.25,16,2.83,11.72,4.73,7.15-1.3-6-1.3-6,9,2.33.64,12.48-15.93-1.06-13.88-7.67c1.66-5.31-4.97-6.26-6.08-12.59",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7892",
    "data-name": "Caminho 7892",
    d: "M334.18,70.53c-3.87-2-10.42-3.65-14.15,2.63-1.76,3-1.08,7-1.08,7l11.39.75Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7893",
    "data-name": "Caminho 7893",
    d: "M317.61,78.18h0a.26.26,0,0,1-.24-.27c0-.17.29-4.19,2.72-6.71,5.87-6.1,12.75-1,14.71.65a.25.25,0,0,1-.32.38c-1.89-1.62-8.47-6.47-14-.69-2.3,2.39-2.58,6.36-2.58,6.4a.25.25,0,0,1-.257.243.184.184,0,0,1-.033,0",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7894",
    "data-name": "Caminho 7894",
    d: "M331.85,88a6.888,6.888,0,0,1-1.65,4.28c-1.38,1.62-3,.82-3.33-1-.33-1.61,0-4.4,1.74-5.37s3.26.27,3.24,2.09",
    fill: "#1ed6bb"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7895",
    "data-name": "Caminho 7895",
    d: "M330.05,164.12s.54,58.15,5.58,90.55c4.08,26.17,11.61,86.69,11.61,86.69h11.43s1.11-58.43-1-84.31c-5.23-65.5,8.28-77.75-2.62-92.93Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13735",
    "data-name": "Grupo 13735",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13734",
    "data-name": "Grupo 13734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13733",
    "data-name": "Grupo 13733",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7896",
    "data-name": "Caminho 7896",
    d: "M330.05,164.12s.54,58.15,5.58,90.55c4.08,26.17,11.61,86.69,11.61,86.69h11.43s1.11-58.43-1-84.31c-5.23-65.5,8.28-77.75-2.62-92.93Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13738",
    "data-name": "Grupo 13738",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13737",
    "data-name": "Grupo 13737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13736",
    "data-name": "Grupo 13736",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7897",
    "data-name": "Caminho 7897",
    d: "M336.06,190.5c4,17.55.81,45.19-1.38,57.36-2.32-18.48-3.49-42.43-4.07-60,2.07-3.34,4.03-3.56,5.45,2.64"
  }))))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7898",
    "data-name": "Caminho 7898",
    d: "M345.68,341.58h14.55l.76-5.1-15.39-.52Z",
    fill: "#ff6461"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7899",
    "data-name": "Caminho 7899",
    d: "M349.83,115c1.37-2.72,8.73-4.43,12.75-4.42l3,13.36s-8,11.89-11.34,10.63c-3.93-1.45-7.34-13.7-4.41-19.57",
    fill: "#ff6461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13741",
    "data-name": "Grupo 13741",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13740",
    "data-name": "Grupo 13740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13739",
    "data-name": "Grupo 13739",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7900",
    "data-name": "Caminho 7900",
    d: "M349.83,115c1.37-2.72,8.73-4.43,12.75-4.42l3,13.36s-8,11.89-11.34,10.63c-3.93-1.45-7.34-13.7-4.41-19.57"
  }))))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7901",
    "data-name": "Caminho 7901",
    d: "M341.35,338.31a.19.19,0,0,0,0-.19.2.2,0,0,0-.21-.11c-.42.07-4.12.65-4.62,1.71a.648.648,0,0,0,0,.63,1.1,1.1,0,0,0,.86.57c1.21.12,3-1.56,3.9-2.58Zm-4.44,1.54c.34-.56,2.26-1.08,3.72-1.35-1.32,1.34-2.48,2.09-3.16,2a.71.71,0,0,1-.56-.38.248.248,0,0,1,0-.25.014.014,0,0,1,0-.02",
    fill: "#ff6461"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7902",
    "data-name": "Caminho 7902",
    d: "M341.35,338.31h0a.19.19,0,0,0,0-.19c-.06-.07-1.54-1.78-2.91-1.87a1.44,1.44,0,0,0-1.09.37c-.41.37-.37.69-.27.89.43.86,3.09,1.16,4.16.93a.181.181,0,0,0,.11-.13m-3.91-1.26a.786.786,0,0,1,.16-.18,1,1,0,0,1,.79-.27,4.6,4.6,0,0,1,2.39,1.47c-1.19.1-3.11-.26-3.37-.78a.239.239,0,0,1,.03-.24",
    fill: "#ff6461"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7903",
    "data-name": "Caminho 7903",
    d: "M350.08,334.76l-7.66,3.41-3.41-7.11-4.46-9.3-.53-1.08,7.66-3.41.59,1.22,4.32,9.01Z",
    fill: "#1ed6bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13744",
    "data-name": "Grupo 13744",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13743",
    "data-name": "Grupo 13743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13742",
    "data-name": "Grupo 13742",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7904",
    "data-name": "Caminho 7904",
    d: "M346.59,327.5l-7.58,3.56-4.46-9.3,7.72-3.27Z"
  }))))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7905",
    "data-name": "Caminho 7905",
    d: "M321.07,164.12S296.6,225,303.23,253.6c6,25.89,32.5,74.92,32.5,74.92L346,323.38s-16.39-59.19-18.16-72.05c-3.46-25,18.77-60.33,18.77-87.21Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13747",
    "data-name": "Grupo 13747",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13746",
    "data-name": "Grupo 13746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13745",
    "data-name": "Grupo 13745",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7906",
    "data-name": "Caminho 7906",
    d: "M321.07,164.12S296.6,225,303.23,253.6c6,25.89,32.5,74.92,32.5,74.92L346,323.38s-16.39-59.19-18.16-72.05c-3.46-25,18.77-60.33,18.77-87.21Z",
    fill: "#fff"
  }))))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7907",
    "data-name": "Caminho 7907",
    d: "M341.06,337.1l7.6-5.53a.66.66,0,0,1,.88.06l5.25,5.39a1.35,1.35,0,0,1-.1,1.907,1.463,1.463,0,0,1-.115.093c-2.69,1.88-4.08,2.66-7.42,5.09-2.06,1.5-6.16,4.81-9,6.88s-5-.63-4-1.74c4.48-5,5.42-8.1,6.12-10.91a2.167,2.167,0,0,1,.78-1.24",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7908",
    "data-name": "Caminho 7908",
    d: "M335.07,330.69l13.23-6.05-1.69-5.39-14.17,6.46Z",
    fill: "#ff6461"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7909",
    "data-name": "Caminho 7909",
    d: "M327.56,114.36c-1.09-2.84-10.65-6-15.45-7L310,123.08s7.84,11.26,11.27,10.33c4.06-1.1,8.65-12.96,6.29-19.05",
    fill: "#ff6461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13750",
    "data-name": "Grupo 13750",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13749",
    "data-name": "Grupo 13749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13748",
    "data-name": "Grupo 13748",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7910",
    "data-name": "Caminho 7910",
    d: "M327.56,114.36c-1.09-2.84-10.65-6-15.45-7L310,123.08s7.84,11.26,11.27,10.33c4.06-1.1,8.65-12.96,6.29-19.05"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7911",
    "data-name": "Caminho 7911",
    d: "M317.07,113.57s-4,1.4,4,50.55h34c-.57-13.84-.59-22.38,6-50.8a100.279,100.279,0,0,0-14.45-1.9,107.525,107.525,0,0,0-15.44,0,142.554,142.554,0,0,0-14.11,2.15",
    fill: "#ff6461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13753",
    "data-name": "Grupo 13753",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13752",
    "data-name": "Grupo 13752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13751",
    "data-name": "Grupo 13751",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7912",
    "data-name": "Caminho 7912",
    d: "M317.07,113.57s-4,1.4,4,50.55h34c-.57-13.84-.59-22.38,6-50.8a100.279,100.279,0,0,0-14.45-1.9,107.525,107.525,0,0,0-15.44,0,142.554,142.554,0,0,0-14.11,2.15"
  }))))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7913",
    "data-name": "Caminho 7913",
    d: "M355.6,162.13l1.53,3c.12.24-.16.48-.55.48H320.9c-.31,0-.56-.15-.58-.35l-.31-3c0-.21.25-.39.58-.39H355a.61.61,0,0,1,.6.26",
    fill: "#ff6461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13756",
    "data-name": "Grupo 13756",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13755",
    "data-name": "Grupo 13755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13754",
    "data-name": "Grupo 13754",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7914",
    "data-name": "Caminho 7914",
    d: "M355.6,162.13l1.53,3c.12.24-.16.48-.55.48H320.9c-.31,0-.56-.15-.58-.35l-.31-3c0-.21.25-.39.58-.39H355a.61.61,0,0,1,.6.26",
    fill: "#fff"
  }))))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7915",
    "data-name": "Caminho 7915",
    d: "M351,166h.92c.19,0,.33-.1.31-.21l-.43-4c0-.12-.17-.21-.35-.21h-.93c-.18,0-.32.09-.31.21l.43,4c-.01.09.15.21.36.21",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7916",
    "data-name": "Caminho 7916",
    d: "M328.61,166h.92c.18,0,.32-.1.31-.21l-.43-4c0-.12-.17-.21-.36-.21h-.92c-.19,0-.32.09-.31.21l.43,4c.01.09.17.21.36.21",
    fill: "#263238"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blocked.d733ae8003709e1e22779a4a5350f795.svg";